<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="component.component_type_id"
          autofocus
          field-name="component_type"
          source-type="component-types"
          translate
          sorted
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.manufacturer"
          field-name="manufacturer"
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.part_number"
          field-name="part_number"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.serial_number"
          field-name="serial_number"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.year_of_manufacture"
          field-name="year_of_manufacture"
          rules="min:4|max:4"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.certificate_number"
          field-name="certificate_number"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="component.certification_at"
          field-name="certification_at"
          rules="date|required"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.status_at_certification"
          field-name="status_at_certification"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.exhibitor"
          field-name="exhibitor"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="component.logcard_number"
          field-name="logcard_number"
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="component.maintenanced_at"
          field-name="maintenanced_at"
          rules="date"
        />
      </v-col>

      <v-col
        cols="12"
        md="12"
      >
        <validated-text-field
          v-model="component.comment"
          field-name="comment"
          type="text"
        />
      </v-col>
    </v-row>
    <material-card
      v-if="installationOn"
      color="green"
      :title="$t('installation')"
      class="mb-6 pb-2 card-block light-green lighten-4"
    >
      <v-row class="px-2">
        <v-col cols="12" md="3">
          <data-selector
            v-model="component.installation_plane_id"
            field-name="reg_num"
            source-type="planes-maintenance"
          />
        </v-col>
        <v-col cols="12" md="3">
          <date-field
            v-model="component.installation_date"
            field-name="installation_date"
            rules="date"
          />
        </v-col>
        <v-col cols="12" md="6">
          <validated-text-field
            v-model="component.installation_comment"
            field-name="comment"
            type="text"
          />
        </v-col>
      </v-row>
    </material-card>

    <material-card
      color="accent"
      :title="$t('limitations')"
      class="mb-6 pb-2 card-block"
    >
      <v-row class="px-2">
        <v-col
          cols="12"
          md="3"
        >
          <v-checkbox
            v-model="component.date_limiter"
            :label="$t('fields.date_limiter')"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-checkbox
            v-model="component.takeoff_limiter"
            :label="$t('fields.takeoff_limiter')"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-checkbox
            v-model="component.flight_limiter"
            :label="$t('fields.flight_limiter')"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-checkbox
            v-model="component.engine_limiter"
            :label="$t('fields.engine_limiter')"
          />
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="panel"
        class="pa-3"
        multiple
      >
        <v-expansion-panel v-show="component.date_limiter">
          <v-expansion-panel-header>
            {{ $t('fields.date_limiter') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                md="3"
              />
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.cycle_date"
                  field-name="cycle_date"
                  rules=""
                  type="number"
                  autofocus
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <date-field
                  v-model="component.limit_date"
                  field-name="limit_date"
                  rules="date"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <date-field
                  v-model="component.lifetime_date"
                  field-name="lifetime_date"
                  rules="date"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="component.takeoff_limiter">
          <v-expansion-panel-header>
            {{ $t('fields.takeoff_limiter') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.start_counter_takeoff"
                  field-name="start_counter_takeoff"
                  rules="numeric"
                  type="number"
                  autofocus
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.cycle_counter_takeoff"
                  field-name="cycle_counter_takeoff"
                  rules="numeric"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.limit_counter_takeoff"
                  field-name="limit_counter_takeoff"
                  rules="numeric"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.lifetime_counter_takeoff"
                  field-name="lifetime_counter_takeoff"
                  rules="required_if:takeoff_limiter,1"
                  type="number"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="component.flight_limiter">
          <v-expansion-panel-header>
            {{ $t('fields.flight_limiter') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.start_counter_flight"
                  field-name="start_counter_flight"
                  rules="double"
                  type="number"
                  autofocus
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.cycle_counter_flight"
                  field-name="cycle_counter_flight"
                  rules="double"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.limit_counter_flight"
                  field-name="limit_counter_flight"
                  rules="double"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.lifetime_counter_flight"
                  field-name="lifetime_counter_flight"
                  rules="required_if:flight_limiter,1"
                  type="number"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="component.engine_limiter">
          <v-expansion-panel-header>
            {{ $t('fields.engine_limiter') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.start_counter_engine"
                  field-name="start_counter_engine"
                  rules="double"
                  type="number"
                  step="0.01"
                  autofocus
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.cycle_counter_engine"
                  field-name="cycle_counter_engine"
                  rules="double"
                  type="number"
                  step="0.01"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.limit_counter_engine"
                  field-name="limit_counter_engine"
                  rules="double"
                  type="number"
                  step="0.01"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <validated-text-field
                  v-model="component.lifetime_counter_engine"
                  field-name="lifetime_counter_engine"
                  rules="required_if:engine_limiter,1|double"
                  type="number"
                  step="0.01"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </material-card>

    <app-card class="my-4 text-center" justify="center">
      <v-card-title class="justify-center">
        <h6 class="text-h6 mb-2 text--secondary">
          {{ $t('fields.component_photo') }}
        </h6>
      </v-card-title>
      <v-card-text class="d-flex flex-column justify-space-between align-center">
        <v-img
          v-if="component.avatar"
          max-width="700px"
          :lazy-src="'data:image/jpeg;base64,' + component.avatar.thumbnail"
          :src="dataUrl"
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <upload-files
          filter="avatar"
          source-type="avatar"
          :upload-params="component"
          class="mt-2"
          @success="uploaded"
        />
      </v-card-actions>
    </app-card>
  </v-container>
</template>

<script>
  export default {
    name: 'EditComponent',
    props: {
      component: Object,
      installationOn: Boolean,
    },
    data: () => ({
      panel: [0, 1, 2, 3],
    }),
    computed: {
      dataUrl () {
        return process.env.VUE_APP_API_URL + '/api/storage/avatar/' + this.component.avatar_id
      },
    },
    methods: {
      uploaded (response) {
        this.component.avatar_id = response.id
        this.component.avatar = response
        console.log(response.id)
      },
    },
  }
</script>
